import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { generate } from "library/guid/index.mjs"
import { DialogContent, DialogTitle, Grid, Stack } from "@mui/material"
import { BoundAutocomplete, BoundTextField } from "lib/@components/binding/bound-components"
import { BoundPictureListEditor } from "lib/@components/document-viewer/picture-list-editor"
import { uniqueValues } from "routes/asset-register/controller/uniqueValues"
import { Bound } from "lib/@components/binding/Bound"

const NewAsset = Symbol("NewAsset")

export function EditAssetDialog({ register, source = { id: generate(), [NewAsset]: true } }) {
    const {
        systems = [],
        categories = [],
        types = [],
        floors = [],
        facilities = [],
        spaces = [],
        manufacturers = [],
    } = uniqueValues.useResultsOnce(register) ?? {}
    return (
        <Bound hideDescription>
            <DataInputDialog initialValue={{ ...source }}>
                <DialogTitle>{source?.[NewAsset] ? "Create Asset" : "Edit Asset"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item md={6} xs={12}>
                            <Stack spacing={1} sx={{ pt: 2 }}>
                                <BoundTextField
                                    autoFocus
                                    yup="string.trim.required"
                                    field="name"
                                    data-cy="edit-asset-name"
                                />
                                <BoundTextField yup="string.trim.required" field="tag" data-cy="edit-asset-tag" />
                                <BoundTextField field="description" data-cy="edit-asset-description" />
                                <BoundAutocomplete
                                    freeSolo
                                    options={categories}
                                    field="category"
                                    data-cy="edit-asset-category"
                                />
                                <BoundAutocomplete
                                    freeSolo
                                    options={systems}
                                    field="system"
                                    data-cy="edit-asset-system"
                                />
                                <BoundAutocomplete
                                    freeSolo
                                    options={facilities}
                                    field="facility"
                                    data-cy="edit-asset-facility"
                                />
                                <BoundAutocomplete freeSolo options={floors} field="floor" data-cy="edit-asset-floor" />
                                <BoundAutocomplete freeSolo options={spaces} field="space" data-cy="edit-asset-space" />
                            </Stack>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <Stack spacing={1} sx={{ pt: 2 }}>
                                <BoundAutocomplete freeSolo options={types} field="type" data-cy="edit-asset-type" />
                                <BoundTextField field="barcode" data-cy="edit-asset-barcode" />
                                <BoundTextField field="code" data-cy="edit-asset-code" />
                                <BoundAutocomplete
                                    freeSolo
                                    options={manufacturers}
                                    field="manufacturer"
                                    data-cy="edit-asset-manufacturer"
                                />
                                <BoundTextField field="model" data-cy="edit-asset-model" />
                                <BoundTextField field="serialNumber" data-cy="edit-asset-serialNumber" />
                                <BoundPictureListEditor field="picture" />
                            </Stack>
                        </Grid>
                    </Grid>
                </DialogContent>
            </DataInputDialog>
        </Bound>
    )
}
